import { ModelBase } from '../../shared/base/model-base';

export class SyllabusImage extends ModelBase {
  name: string;
  downloadURL: string;
  owner?: string;
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/shared/syllabus-image.ts